import lang from "@/views/modules/EmailTemplates/language/en";
import tinymce from 'vue-tinymce-text-editor';

export default {
    name: "edit-email-template",
    components: {
        'tinymce': tinymce,
    },
    data() {
        return {
            loading: true,
            template: {
                'name':'',
                'template_text':'',
            },
            error_message:{},
            process:false,
            lang:[],
        }
    },
    mounted() {
        this.getEmailTemplates();
        this.lang = lang;
    },
    methods: {
        SaveTemplate() {
            const self = this;
            self.loading = true;
            axios.put('api/modules/emailtemplates/'+self.$route.params.id, self.template).then(function (response) {
                self.loading = false;
                
                self.$router.push('/modules/emailtemplates/' + self.$route.params.id + '/detail');
            }).catch(function () {
                self.loading = false;
            });
        },
        getEmailTemplates(){
            const self = this;
             window.currentAction = 'list';
                axios.get('api/modules/emailtemplates/'+self.$route.params.id).then(function(response){
                self.template.name = response.data.name;
                self.template.template_text = response.data.template_text;
            }).catch(function(e){
                self.loading = false;
            })
        }
    }
}